import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as categories from 'catalog/actions/categories'
import {ListGroup} from 'reactstrap';
import Category from 'catalog/components/Category';
import DnDContext from 'catalog/containers/DnDContext'
import DroppableContext from 'catalog/containers/DroppableContext'
import PropTypes from 'prop-types'
import Loading from 'apa/components/Loading';

@connect(
    state => {
        return {
            categoryList: state.categories.categoryList,
            categoryListLoading: state.categories.categoryListLoading,
        }
    },
    dispatch => {
        return {
            fetchCategoryList: () => dispatch(categories.fetchCategoryList()),
            reorderCategoryList: (result, subcategories) => dispatch(categories.reorderCategoryList(result, subcategories))
        }
    }
)
export default class CategoryList extends Component {

    componentDidMount() {
        this.props.fetchCategoryList();
    }

    render() {
        const {
            categoryList,
            categoryListLoading
        } = this.props;
        if(categoryListLoading) {
            return <Loading />
        }
        return (
            <ListGroup>
                <DnDContext>
                    <DroppableContext droppableId={'category'}>
                        {
                            categoryList.map(
                                (category, index) => <Category index={index} key={`category_${index}`}
                                                               category={category}/>
                            )
                        }
                    </DroppableContext>
                </DnDContext>
            </ListGroup>
        )
    }
}

CategoryList.propTypes = {
    categoryList: PropTypes.array,
    fetchCategoryList: PropTypes.func,
    reorderCategoryList: PropTypes.func
}
